<template>
  <form ref="asyncForm" :action="formPath" method="POST" @submit.prevent="submit">
    <input type="hidden" name="authenticity_token" :value="csrfToken" />
    <slot></slot>
  </form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AsyncForm",
  props: {
    formPath: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      csrfToken: "getCsrfToken",
    }),
  },
  methods: {
    ...mapActions({
      fetchCsrfToken: "fetchCsrfToken",
    }),
    async submit() {
      await this.fetchCsrfToken();
      this.$nextTick(function() {
        this.$refs.asyncForm.submit();
      });
    },
  },
};
</script>
